import { Habit } from '@griply/types';
import { buildGoalHabitSections, getWeekStartsOn } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useHabits } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useGoalSections } from 'shared/hooks/use-goal-sections';
import { useUser } from 'shared/hooks/use-user';

export const useGoalHabitSections = () => {
  const today = useToday();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  const habits = useHabits({
    uncompletedOnly: true,
    unArchivedOnly: true,
    undeletedOnly: true,
  });
  const goals = useGoals();

  const goalSections = useGoalSections();

  const goalSorting = useMemo(
    () => goalSections.map(({ id }) => id),
    [goalSections],
  );

  const sections = useMemo(
    () =>
      buildGoalHabitSections({
        habits,
        goals,
        goalSorting,
        habitSortingMode: user?.settings?.habitSortingMode,
        habitGroupSorting: user?.settings?.habitGroupSorting?.goal?.sorting,
        today,
        weekStartsOn,
      }).map((group) => ({
        id: group.goalId,
        items: group.tasks as Habit[],
      })),
    [
      habits,
      goals,
      goalSorting,
      user?.settings?.habitSortingMode,
      user?.settings?.habitGroupSorting?.goal?.sorting,
      today,
      weekStartsOn,
    ],
  );

  return {
    sections,
    habits,
  };
};
